import PosthogService from '~/services/posthog/PosthogService';

export function fireDashboardPendingReviewClicked(): void {
  PosthogService.getInstance().track('dental_portal:dashboard:pending_review_clicked');
}
